import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, AfterViewChecked, OnDestroy } from '@angular/core';
import { EventViewModel, LiveEventViewModel, UserAuthenticationViewModel, ExhibitDesignerViewModel } from 'src/app/_models/generatedModels';
import { ChatViewModel } from 'src/app/_models/models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { HubConnection } from '@microsoft/signalr';
import { of, interval, Subscription } from 'rxjs';
import { ExhibitService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'exhibit-materials',
  templateUrl: 'exhibit-materials.component.html',
})
export class ExhibitMaterialsComponent implements OnInit {
  initialized = false;

  @Input() exhibit: ExhibitDesignerViewModel;
  @Output()
  closed = new EventEmitter();

  constructor(public auth: AuthenticationService, private exhibitService: ExhibitService) {}

  ngOnInit(): void {
    this.initialized = true;
  }

  materialsDownloaded(){
    this.exhibitService.filesDownloaded(this.exhibit.id).subscribe();
  }

  close() {
    this.closed.emit();
  }
}
